import { gql } from '@apollo/client';

// 干线卸车明细 drawer 顶部计数：已卸运单数 + 已卸包牌数（读 tms_loading_order_detail）
export const GET_UNLOADED_ORDER_DETAIL_COUNT = gql`
    query GetUnloadedOrderDetailCount($taskId: Long!, $taskWaypointId: Long!) {
        getUnloadedOrderDetailCount(taskId: $taskId, taskWaypointId: $taskWaypointId) {
            waypointId
            parcelCount
            bagCount
        }
    }
`;

export interface GetUnloadedOrderDetailCountResponse {
    getUnloadedOrderDetailCount: {
        waypointId: number;
        parcelCount: number;
        bagCount: number;
    };
}

export interface GetUnloadedOrderDetailCountVariables {
    taskId: number;
    taskWaypointId: number;
}
